const routes = [
    {
        path: "/bind-policy-for-wx-and-h5",
        component: () =>
            import(
                "../../views/bind-policy-for-wx-and-h5/BindPolicyForWXAndH5.vue"
            ),
        children: [
            {
                path: "private-policy-doc",
                component: () =>
                    import("../../components/bind-policy/PrivatePolicyDoc.vue"),
                meta: { title: "隐私政策" },
            },
            {
                path: "user-authorization-doc",
                component: () =>
                    import(
                        "../../components/bind-policy/UserAuthorizationDoc.vue"
                    ),
                meta: { title: "个人信息授权书" },
            },
            {
                path: "face-authorization-doc",
                component: () =>
                    import(
                        "../../components/bind-policy/FaceAuthorizationDoc.vue"
                    ),
                meta: { title: "人脸信息处理授权书", close: true },
            },
            {
                path: "face-authorization-doc-tx",
                component: () =>
                    import(
                        "../../components/bind-policy/FaceAuthorizationDocTx.vue"
                    ),
                meta: { title: "人脸信息处理授权书", close: true },
            },
        ],
        meta: { name: "绑定保单" },
    },
    {
        path: "/bind-policy-again",
        redirect: "/bind-policy-again/face",
        component: () =>
            import("../../views/bind-policy-again/BindPolicyAgain.vue"),
        children: [
            {
                path: "face",
                component: () =>
                    import(
                        "../../components/bind-policy-by-face/BindPolicyByFace.vue"
                    ),
            },
            {
                path: "sms-m",
                component: () =>
                    import(
                        "../../views/bind-policy-for-wx-and-h5/BindPolicyForWXAndH5.vue"
                    ),
            },
        ],
        meta: { name: "绑定保单" },
    },
];

export default routes;
